import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="alpha-container py-24 text-center" data-testid="page-404">
      <div className="font-display text-7xl font-semibold alpha-gradient-text">404</div>
      <h1 className="mt-4 font-display text-2xl font-semibold">We couldn't find that page.</h1>
      <p className="mt-2 text-[color:var(--alpha-mute)]">The link may be outdated, or the page may have moved.</p>
      <Link to="/" className="alpha-btn-primary mt-6 inline-flex">Back to home</Link>
    </div>
  );
}
